var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-popover"},[_c('el-popover',_vm._b({},'el-popover',_vm.$attrs,false),[_c('span',{staticClass:"see-table-btn",attrs:{"slot":"reference"},slot:"reference"},[_vm._t("popover-btn")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }